import { create } from "apisauce";

export const createApi = () => {
  const api = create({
    baseURL: process.env.REACT_APP_URL_API,
    headers: {
      "Cache-Control": "no-cache",
    },
    timeout: 300000,
    withCredentials: true,
  });

  // Security
  const login = (credentialResponse) => {
    return api.post(`/api/auth/login`, credentialResponse);
  };

  const logout = () => {
    return api.post(`/api/auth/logout`);
  };

  const validateToken = () => {
    return api.get(`/api/auth/validateToken`, {});
  };

  // User
  const getUsers = () => {
    return api.get(`/api/users`);
  };

  const getUserActionLogs = (userId) => {
    return api.get(`/api/users/${userId}/action-logs`);
  };

  const saveUser = (user) => {
    return api.post(`/api/users/${user.id}`, user);
  };

  const createUser = (user) => {
    return api.post(`/api/users`, user);
  };

  const exportUsers = () => {
    return api.get(`/api/users/export`);
  };

  const savePinnedTabs = (tabs) => api.post(`/api/users/pinnedTabs`, { pinnedTabs: tabs });

  // Roles
  const getRoles = () => {
    return api.get(`/api/roles`);
  };

  const getRolesWithCount = () => {
    return api.get(`/api/roles/with-count`);
  };

  const editRole = (role) => {
    return api.post(`/api/roles/${role.id}`, role);
  };

  const createRole = (role) => {
    return api.post(`/api/roles`, role);
  };

  // Employee
  const getEmployees = () => {
    return api.get(`/api/employees`);
  };

  const getEmployeeNames = () => {
    return api.get(`/api/employees/names`);
  };

  // Dictionary Value
  const getDictionaryValuesGrouped = () => {
    return api.get(`/api/dictionary/types/values`);
  };

  // Structure - Division
  const getDivisionsStructure = () => {
    return api.get(`/api/teams/divisions`);
  };

  // Structure - Department
  const getDepartmentsStructure = (divisionId) => {
    if (divisionId) {
      return api.get(`/api/teams/departments?divisionId=${divisionId}`);
    }
    return api.get(`/api/teams/departments`);
  };

  // Structure - Team
  const getTeamsStructure = (departmentId) => {
    if (departmentId) {
      return api.get(`/api/teams/teams?departmentId=${departmentId}`);
    }
    return api.get(`/api/teams/teams`);
  };

  // Executive Leadership
  const getExecutiveLeadership = () => api.get(`/api/executive-leadership`);
  const saveExecutiveLeadership = (members) => api.post(`/api/executive-leadership`, { members });

  return {
    login,
    logout,

    // User
    validateToken,
    getUsers,
    saveUser,
    createUser,
    exportUsers,
    getUserActionLogs,
    savePinnedTabs,

    // Roles
    getRoles,
    getRolesWithCount,
    editRole,
    createRole,

    // Employee
    getEmployees,
    getEmployeeNames,

    // Dictionary Value
    getDictionaryValuesGrouped,

    // Structure
    getDivisionsStructure,
    getDepartmentsStructure,
    getTeamsStructure,

    // Executive Leadership
    getExecutiveLeadership,
    saveExecutiveLeadership,
  };
};

// Creates a singleton
export default createApi();
